export enum ELocalStorageKeys {
	STATE = 'bodil-booking-state',
	account = 'bodil-booking-account',
  cookies = 'bodil-cookies-accept',
  message_accepted = 'bodil-message-accepted',
}
